import {useMutation, useQueryClient} from '@tanstack/react-query';
import campaignApprovalStepUpdaters from '@/api/updaters/campaignApprovalStep';
import updateCampaignApprovalStepsCache from '@/hooks/mutations/updateCampaignApprovalStepsCache';
import campaignQueryKey from '@/hooks/queries/use-campaign-query/campaignQueryKey';

function useAddCampaignApprovalStep({campaignId}: {campaignId: string}) {
  const queryClient = useQueryClient();
  const queryKey = campaignQueryKey(campaignId);

  return useMutation({
    mutationKey: ['campaignApprovalSteps', 'add', campaignId],
    mutationFn: campaignApprovalStepUpdaters.add,
    onMutate: async ({step}) => {
      await queryClient.cancelQueries({queryKey});
      const snapshot = queryClient.getQueryData(queryKey);
      updateCampaignApprovalStepsCache(queryClient, queryKey, (steps) => [
        ...steps,
        {id: `temp-${step}`, campaignId, step},
      ]);
      return {snapshot};
    },
    onError: (_err, _vars, context) => {
      queryClient.setQueryData(queryKey, context?.snapshot);
    },
    onSettled: () => {
      queryClient.invalidateQueries({queryKey});
    },
  });
}

export default useAddCampaignApprovalStep;
